import { ROUTE_TO_NEXT, routeTo } from 'redux-router-kit';
import { addTruthyParamsToUrl, extractParams } from '@zapier/url-utils';

/**
 * This middleware started out as a way to redirect the z/z frontend application
 * to the editor's new NextJS service, but now stands to redirect any "split" page.
 *
 * When a team splits their service out of the monorepo, they may use a subpath
 * to host that service. Example: zapier.com/app/settings
 *
 * We want to make sure the code in z/z does not get rendered for that path,
 * so instead of doing a client-side route change, which does not make any requests
 * back to the domain for assets, it will do a hard refresh to make sure we're
 * getting the correct NextJS assets.
 */
const hardRefreshMiddleware = ({ dispatch }) => next => action => {
  if (!action || !action.type) {
    return next(action);
  }

  if (action.type !== ROUTE_TO_NEXT) {
    return next(action);
  }

  const url = action.meta?.url || '';
  const params = extractParams(url);
  const conditions = [
    url.startsWith('/app/editor'),
    url.startsWith('/app/dashboard'),
    url.startsWith('/app/zap/'),
    url.startsWith('/app/settings'),
  ];

  if (
    (!params.redirect || params.redirect === 'false') &&
    conditions.some(Boolean)
  ) {
    // Add a `redirect` param when triggering the refresh,
    // so we can check its presence and not get stuck in an
    // infinite redirect loop the next time a `ROUTE_TO_NEXT` action is dispatched.
    const updatedUrl = addTruthyParamsToUrl(url, {
      redirect: true,
    });

    return dispatch(routeTo(updatedUrl, { exit: true }));
  }

  return next(action);
};

export default hardRefreshMiddleware;
